import cl from "./error.module.css";

export const Error = () => {
  return <div className={cl.error}>Page not found</div>;
};
